(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequiree671"];
var parcelRegister = parcelRequire.register;
parcelRegister("8nwHf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6199d59518af10f8$export$2e2bcd8739ae039; });

var $9SqLn = parcelRequire("9SqLn");
var $6199d59518af10f8$var$ScrollerSlides = {
    init: function(slidesStep) {
        var _this = this;
        var scroller = (0, (/*@__PURE__*/$parcel$interopDefault($9SqLn)))();
        var slides = document.querySelectorAll(".sticky-content .slide");
        // add ratioPercent variable to object that is accessible in other functions //28
        //this.ratioPercent = 42;
        this.ratioPercent = slides.length > 4 ? 42 : 28;
        if (slides.length > 5) this.ratioPercent = 51;
        //console.log(slidesStep.offsetWidth);
        //console.log(window.innerHeight);
        //console.log('ratio: ' + slidesStep.offsetWidth / window.innerHeight);
        var ratio = slidesStep.offsetWidth / window.innerHeight;
        var stickyDiv = document.querySelector(".sticky-div");
        if (window.innerWidth > 1200) {
            var containerWidth = Math.min(stickyDiv.getBoundingClientRect().width, window.innerWidth);
            //this.ratioPercent = (1 / (window.innerWidth/560) * 100).toFixed(1);
            //this.ratioPercent = (1 / (containerWidth/520) * 100).toFixed(1);
            //console.log(this.ratioPercent, slidesStep.offsetHeight);
            //this.ratioPercent = (window.innerWidth - (stickyDiv.getBoundingClientRect().width + slides.getBoundingClientRect().x)) / stickyDiv.getBoundingClientRect().width  * 100;
            //console.log(this.ratioPercent);
            if (window.innerWidth < 1536) {
                //this.ratioPercent = 52;
                //this.ratioPercent = 41;
                this.ratioPercent = slides.length > 4 ? 52 : 41;
                if (slides.length > 5) this.ratioPercent = 60;
            }
            //document.querySelector('.slide-section').style.height = slidesStep.offsetHeight + window.innerHeight*0.8*1.3  + 'px';
            var heightIdx = slides.length > 4 ? 1.7 : 1.2;
            document.querySelector(".slide-section").style.height = slidesStep.offsetHeight + window.innerHeight * heightIdx + "px";
            //document.querySelector('.slide-section').style.height = '2150px';
            //console.log('height: ', parseFloat(slidesStep.offsetHeight) + parseInt(window.innerHeight));
            scroller.setup({
                step: ".slide-section",
                debug: false,
                progress: true,
                offset: 0
            }).onStepEnter(function(response) {
                return _this.handleStepEnter(response, slidesStep);
            }).onStepExit(function(response) {
                return _this.handleStepExit(response, slidesStep);
            }).onStepProgress(function(response) {
                return _this.handleStepProgress(response, slidesStep);
            });
        }
    },
    handleStepEnter: function(response, slidesStep) {
        document.querySelector(".sticky-div").style.position = "fixed";
        slidesStep.querySelectorAll(".slide").forEach(function(slide, idx) {
            if (idx > 0) slide.classList.add("active");
        });
    },
    handleStepExit: function(response, slidesStep) {
        document.querySelector(".sticky-div").style.position = "sticky";
        slidesStep.querySelectorAll(".slide").forEach(function(slide, idx) {
            idx;
        });
    },
    handleStepProgress: function(response, slidesStep) {
        var progress = 100 * response.progress;
        if (progress <= this.ratioPercent) slidesStep.style.transform = "translate3d(-" + progress + "%, 0px, 0px)";
    /*if (window.innerWidth > 1200) {
            if (progress < 35) {
                slidesStep.style.transform = 'translate3d(-' + progress + '%, 0px, 0px)';
            }
        } else {
            if (progress < 60) {
                slidesStep.style.transform = 'translate3d(-' + progress + '%, 0px, 0px)';
            }
        }*/ }
};
var $6199d59518af10f8$export$2e2bcd8739ae039 = $6199d59518af10f8$var$ScrollerSlides;

});
parcelRegister("9SqLn", function(module, exports) {

var $cv9Rk = parcelRequire("cv9Rk");
(function(global, factory) {
    module.exports = factory();
})(undefined, function() {
    "use strict";
    // DOM helper functions
    // public
    function selectAll(selector) {
        var parent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document;
        if (typeof selector === "string") return Array.from(parent.querySelectorAll(selector));
        else if (selector instanceof Element) return [
            selector
        ];
        else if (selector instanceof NodeList) return Array.from(selector);
        else if (selector instanceof Array) return selector;
        return [];
    }
    // SETUP
    function create(className) {
        var el = document.createElement("div");
        el.className = "scrollama__debug-step ".concat(className);
        el.style.position = "fixed";
        el.style.left = "0";
        el.style.width = "100%";
        el.style.zIndex = "9999";
        el.style.borderTop = "2px solid black";
        el.style.borderBottom = "2px solid black";
        var p = document.createElement("p");
        p.style.position = "absolute";
        p.style.left = "0";
        p.style.height = "1px";
        p.style.width = "100%";
        p.style.borderTop = "1px dashed black";
        el.appendChild(p);
        document.body.appendChild(el);
        return el;
    }
    // UPDATE
    function update(param) {
        var id = param.id, step = param.step, marginTop = param.marginTop;
        var index = step.index, height = step.height;
        var className = "scrollama__debug-step--".concat(id, "-").concat(index);
        var el = document.querySelector(".".concat(className));
        if (!el) el = create(className);
        el.style.top = "".concat(marginTop * -1, "px");
        el.style.height = "".concat(height, "px");
        el.querySelector("p").style.top = "".concat(height / 2, "px");
    }
    function generateId() {
        var alphabet = "abcdefghijklmnopqrstuvwxyz";
        var date = Date.now();
        var result = [];
        for(var i = 0; i < 6; i += 1){
            var char = alphabet[Math.floor(Math.random() * alphabet.length)];
            result.push(char);
        }
        return "".concat(result.join("")).concat(date);
    }
    function err$1(msg) {
        console.error("scrollama error: ".concat(msg));
    }
    function getIndex(node) {
        return +node.getAttribute("data-scrollama-index");
    }
    function createProgressThreshold(height, threshold) {
        var count = Math.ceil(height / threshold);
        var t = [];
        var ratio = 1 / count;
        for(var i = 0; i < count + 1; i += 1)t.push(i * ratio);
        return t;
    }
    function parseOffset(x) {
        if (typeof x === "string" && x.indexOf("px") > 0) {
            var v = +x.replace("px", "");
            if (!isNaN(v)) return {
                format: "pixels",
                value: v
            };
            else {
                err("offset value must be in 'px' format. Fallback to 0.5.");
                return {
                    format: "percent",
                    value: 0.5
                };
            }
        } else if (typeof x === "number" || !isNaN(+x)) {
            if (x > 1) err("offset value is greater than 1. Fallback to 1.");
            if (x < 0) err("offset value is lower than 0. Fallback to 0.");
            return {
                format: "percent",
                value: Math.min(Math.max(0, x), 1)
            };
        }
        return null;
    }
    function indexSteps(steps) {
        steps.forEach(function(step) {
            return step.node.setAttribute("data-scrollama-index", step.index);
        });
    }
    function getOffsetTop(node) {
        var top = node.getBoundingClientRect().top;
        var scrollTop = window.pageYOffset;
        var clientTop = document.body.clientTop || 0;
        return top + scrollTop - clientTop;
    }
    var currentScrollY;
    var comparisonScrollY;
    var direction;
    function onScroll(container) {
        var scrollTop = container ? container.scrollTop : window.pageYOffset;
        if (currentScrollY === scrollTop) return;
        currentScrollY = scrollTop;
        if (currentScrollY > comparisonScrollY) direction = "down";
        else if (currentScrollY < comparisonScrollY) direction = "up";
        comparisonScrollY = currentScrollY;
    }
    function setupScroll(container) {
        currentScrollY = 0;
        comparisonScrollY = 0;
        document.addEventListener("scroll", function() {
            return onScroll(container);
        });
    }
    function scrollama() {
        var cb = {};
        var id = generateId();
        var steps = [];
        var globalOffset;
        var containerElement;
        var rootElement;
        var progressThreshold = 0;
        var isEnabled = false;
        var isProgress = false;
        var isDebug = false;
        var isTriggerOnce = false;
        var exclude = [];
        /* HELPERS */ function reset() {
            cb = {
                stepEnter: function() {},
                stepExit: function() {},
                stepProgress: function() {}
            };
            exclude = [];
        }
        function handleEnable(shouldEnable) {
            if (shouldEnable && !isEnabled) updateObservers();
            if (!shouldEnable && isEnabled) disconnectObservers();
            isEnabled = shouldEnable;
        }
        /* NOTIFY CALLBACKS */ function notifyProgress(element, progress) {
            var index = getIndex(element);
            var step = steps[index];
            if (progress !== undefined) step.progress = progress;
            var response = {
                element: element,
                index: index,
                progress: progress,
                direction: direction
            };
            if (step.state === "enter") cb.stepProgress(response);
        }
        function notifyStepEnter(element) {
            var check = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            var index = getIndex(element);
            var step = steps[index];
            var response = {
                element: element,
                index: index,
                direction: direction
            };
            step.direction = direction;
            step.state = "enter";
            // if (isPreserveOrder && check && direction !== "up")
            //   notifyOthers(index, "above");
            // if (isPreserveOrder && check && direction === "up")
            //   notifyOthers(index, "below");
            if (!exclude[index]) cb.stepEnter(response);
            if (isTriggerOnce) exclude[index] = true;
        }
        function notifyStepExit(element) {
            var check = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            var index = getIndex(element);
            var step = steps[index];
            if (!step.state) return false;
            var response = {
                element: element,
                index: index,
                direction: direction
            };
            if (isProgress) {
                if (direction === "down" && step.progress < 1) notifyProgress(element, 1);
                else if (direction === "up" && step.progress > 0) notifyProgress(element, 0);
            }
            step.direction = direction;
            step.state = "exit";
            cb.stepExit(response);
        }
        /* OBSERVERS - HANDLING */ function resizeStep(param) {
            var _param = (0, $cv9Rk._)(param, 1), entry = _param[0];
            var index = getIndex(entry.target);
            var step = steps[index];
            var h = entry.target.offsetHeight;
            if (h !== step.height) {
                step.height = h;
                disconnectObserver(step);
                updateStepObserver(step);
                updateResizeObserver(step);
            }
        }
        function intersectStep(param) {
            var _param = (0, $cv9Rk._)(param, 1), entry = _param[0];
            onScroll(containerElement);
            var isIntersecting = entry.isIntersecting, target = entry.target;
            if (isIntersecting) notifyStepEnter(target);
            else notifyStepExit(target);
        }
        function intersectProgress(param) {
            var _param = (0, $cv9Rk._)(param, 1), entry = _param[0];
            var index = getIndex(entry.target);
            var step = steps[index];
            var isIntersecting = entry.isIntersecting, intersectionRatio = entry.intersectionRatio, target = entry.target;
            if (isIntersecting && step.state === "enter") notifyProgress(target, intersectionRatio);
        }
        /*  OBSERVERS - CREATION */ function disconnectObserver(param) {
            var observers = param.observers;
            Object.keys(observers).map(function(name) {
                observers[name].disconnect();
            });
        }
        function disconnectObservers() {
            steps.forEach(disconnectObserver);
        }
        function updateResizeObserver(step) {
            var observer = new ResizeObserver(resizeStep);
            observer.observe(step.node);
            step.observers.resize = observer;
        }
        function updateResizeObservers() {
            steps.forEach(updateResizeObserver);
        }
        function updateStepObserver(step) {
            var h = window.innerHeight;
            var off = step.offset || globalOffset;
            var factor = off.format === "pixels" ? 1 : h;
            var offset = off.value * factor;
            var marginTop = step.height / 2 - offset;
            var marginBottom = step.height / 2 - (h - offset);
            var rootMargin = "".concat(marginTop, "px 0px ").concat(marginBottom, "px 0px");
            var root = rootElement;
            var threshold = 0.5;
            var options = {
                rootMargin: rootMargin,
                threshold: threshold,
                root: root
            };
            var observer = new IntersectionObserver(intersectStep, options);
            observer.observe(step.node);
            step.observers.step = observer;
            if (isDebug) update({
                id: id,
                step: step,
                marginTop: marginTop,
                marginBottom: marginBottom
            });
        }
        function updateStepObservers() {
            steps.forEach(updateStepObserver);
        }
        function updateProgressObserver(step) {
            var h = window.innerHeight;
            var off = step.offset || globalOffset;
            var factor = off.format === "pixels" ? 1 : h;
            var offset = off.value * factor;
            var marginTop = -offset + step.height;
            var marginBottom = offset - h;
            var rootMargin = "".concat(marginTop, "px 0px ").concat(marginBottom, "px 0px");
            var threshold = createProgressThreshold(step.height, progressThreshold);
            var options = {
                rootMargin: rootMargin,
                threshold: threshold
            };
            var observer = new IntersectionObserver(intersectProgress, options);
            observer.observe(step.node);
            step.observers.progress = observer;
        }
        function updateProgressObservers() {
            steps.forEach(updateProgressObserver);
        }
        function updateObservers() {
            disconnectObservers();
            updateResizeObservers();
            updateStepObservers();
            if (isProgress) updateProgressObservers();
        }
        /* SETUP */ var S = {};
        S.setup = function(param) {
            var step = param.step, parent = param.parent, _param_offset = param.offset, offset = _param_offset === void 0 ? 0.5 : _param_offset, _param_threshold = param.threshold, threshold = _param_threshold === void 0 ? 4 : _param_threshold, _param_progress = param.progress, progress = _param_progress === void 0 ? false : _param_progress, _param_once = param.once, once = _param_once === void 0 ? false : _param_once, _param_debug = param.debug, debug = _param_debug === void 0 ? false : _param_debug, container = param.container, _param_root = param.root, root = _param_root === void 0 ? null : _param_root;
            setupScroll(container);
            steps = selectAll(step, parent).map(function(node, index) {
                return {
                    index: index,
                    direction: undefined,
                    height: node.offsetHeight,
                    node: node,
                    observers: {},
                    offset: parseOffset(node.dataset.offset),
                    top: getOffsetTop(node),
                    progress: 0,
                    state: undefined
                };
            });
            if (!steps.length) {
                err$1("no step elements");
                return S;
            }
            isProgress = progress;
            isTriggerOnce = once;
            isDebug = debug;
            progressThreshold = Math.max(1, +threshold);
            globalOffset = parseOffset(offset);
            containerElement = container;
            rootElement = root;
            reset();
            indexSteps(steps);
            handleEnable(true);
            return S;
        };
        S.enable = function() {
            handleEnable(true);
            return S;
        };
        S.disable = function() {
            handleEnable(false);
            return S;
        };
        S.destroy = function() {
            handleEnable(false);
            reset();
            return S;
        };
        S.resize = function() {
            updateObservers();
            return S;
        };
        S.offset = function(x) {
            if (x === null || x === undefined) return globalOffset.value;
            globalOffset = parseOffset(x);
            updateObservers();
            return S;
        };
        S.onStepEnter = function(f) {
            if (typeof f === "function") cb.stepEnter = f;
            else err$1("onStepEnter requires a function");
            return S;
        };
        S.onStepExit = function(f) {
            if (typeof f === "function") cb.stepExit = f;
            else err$1("onStepExit requires a function");
            return S;
        };
        S.onStepProgress = function(f) {
            if (typeof f === "function") cb.stepProgress = f;
            else err$1("onStepProgress requires a function");
            return S;
        };
        return S;
    }
    return scrollama;
});

});


})();
//# sourceMappingURL=scrollerslides.c2068ac6.js.map
